import React from 'react';
import { styled } from '@mui/material/styles';
import { getIcon } from '../../services/agilityTranslations';

const Container = styled('div')(({ theme: _theme }) => ({
  padding: '40px 15px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));
const TitleContainer = styled('div')(({ theme: _theme }) => ({
  maxWidth: '800px',
  alignSelf: 'center',
}));
const IntroTitle = styled('div')(({ theme }) => ({
  fontSize: '1.65rem',
  textTransform: 'uppercase',
  color: theme.palette.primary.dark,
  fontWeight: 600,
  margin: '8px 20px 8px 0px',
  alignSelf: 'center',
}));
const IconContainer = styled('div')(({ theme: _theme }) => ({
  fontSize: '1.30rem',
  maxWidth: '70px',
  alignSelf: 'center',
}));
const _Icon = styled('div')(({ theme: _theme }) => ({
  maxWidth: '50px',
  margin: '13px 20px 8px 0px',
  alignSelf: 'center',
}));
const TextContainer = styled('div')(({ theme: _theme }) => ({
  maxWidth: '800px',
  alignSelf: 'center',
}));
const Description = styled('div')(({ theme }) => ({
  fontSize: '1.00rem',
  fontWeight: 300,
  color: theme.palette.common.black,
  margin: 5,
}));

const TextWithIcon = ({ module }) => {
  const { fields } = module;

  return (
    <Container>
      <a id={fields.anchor}></a>
      <TitleContainer>
        <IntroTitle>{fields.title}</IntroTitle>
      </TitleContainer>
      {fields.iconName && (
        <IconContainer>
          {getIcon(fields.iconName, fields.iconColor, '3.00rem')}
        </IconContainer>
      )}
      <TextContainer>
        <Description>{fields.description}</Description>
      </TextContainer>
    </Container>
  );
};

export default TextWithIcon;

